import { Route } from 'react-router-dom';
import { publicRoutes } from './routes';

export const PublicRoutes = () =>
  publicRoutes.map((route, index) => <Route key={`route-${index}`} {...route} />);
